import { CssClass, IOmniaCommand } from "../../types"
import { getIconClass, isFunction, isNumber } from "../../utils/utils"

export function createTableMenuDirective(): ng.IDirective {

    return {

        templateUrl: 'shared/components/tablemenu/tablemenu.html',

        scope: {
            "items": "=",
            "columns": "=",
            "datacontext": "="
        },

        controller: TableMenuCtrl,
        controllerAs: "vm",
        bindToController: true,

        link: (scope: ng.IScope, element, attrs, ctrl: TableMenuCtrl) => {

            ctrl.setup(scope);

        }

    }

}

class TableMenuCtrl {

    private scope: ng.IScope;

    columns: number;
    items: any[];
    datacontext: any;

    columnCssClass: string;
    columnsArray: any[];

    setup(scope: ng.IScope) {

        this.scope = scope;

        scope.$watch("vm.columns", () => this.updateColumns());

    }

    private updateColumns() {

        const { columns } = this

        if (isNumber(columns)) {
            this.columnCssClass = `menu menu-${columns}` as CssClass
            this.columnsArray = Array(columns);
        }

    }

    canExecute(command: IOmniaCommand) {

        const handler = command.canExecute;
        if (!isFunction(handler)) return true;

        return handler.apply(command, [this.datacontext]);

    }

    execute(command: IOmniaCommand) {

        const handler = command.execute;

        if (isFunction(handler)) {
            handler.apply(command, [this.datacontext]);
        }

    }

    checkPopup(command: any) {
        return command["popupTemplate"];
    }

    getIcon(command: IOmniaCommand) {
        return getIconClass(command.icon)
    }

}
